export default "__VITE_ASSET__DfJ0s6tC__"